import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCNote from '../../../../components/Simple/SMCNote';
import {dateAndTimeToString} from '../../../../utils/utils';

const pageSchema = GatewayGetSchema.pages.internetMonitoring;
const pageId = pageSchema.pageId;
const statusPageSchema = GatewayGetSchema.pages.status;
const statusPageId = statusPageSchema.pageId;

function GatewayInternetMonitoring({
    gatewayObject
}) {

    const { t } = useTranslation();
    const pageData = gatewayObject[pageId];

    const statusPageData = gatewayObject[statusPageId];
    const lastFetchTime = statusPageData[statusPageSchema.lastFetchTime];
    
    const internetProbingServers = pageData[pageSchema.internetProbingServers];
    const internetProbingServersSchema = pageSchema.internetProbingServersSchema;
   
    const columns = [
     { id: 'connName', accessor: internetProbingServersSchema.connName, header: 'Connection', width: 90 },   
     { id: 'name', accessor: internetProbingServersSchema.name, header: 'Server Name', width: 120 },
     { id: 'ipAdd', accessor: internetProbingServersSchema.ipAdd, header: 'IP Address', width: 100 },
     { id: 'packetLoss', accessor: internetProbingServersSchema.packetLoss, header: 'Packet Loss', width: 95 },
     { id: 'failures', accessor: internetProbingServersSchema.failures, header: 'Failures', width: 75 },
     { id: 'avgLatency', accessor: internetProbingServersSchema.avgLatency, header: 'Avg. Latency', width: 100 },
     { id: 'minLatency', accessor: internetProbingServersSchema.minLatency, header: 'Min Latency', width: 100 },
     { id: 'maxLatency', accessor: internetProbingServersSchema.maxLatency, header: 'Max Latency', width: 100 },
     { id: 'jitter', accessor: internetProbingServersSchema.jitter, header: 'Jitter', width: 90 },
        
    ]

    return (
        <EditorLayout>

            <SMCNote>{t('SMP.INTERNET_MONITORING_R80_20')}</SMCNote>
            <SMCLabel><b>Last update time:</b> {dateAndTimeToString(lastFetchTime, true)}</SMCLabel>
           
            <SMCTable
                columns={columns}
                content={internetProbingServers}
                hasCheckboxColumn={false}
            />
        </EditorLayout>
    );
}

export default GatewayInternetMonitoring;